import { webSocketState } from '@/store/modules/websocket/websocket.state';
import { webSocketMutations } from '@/store/modules/websocket/websocket.mutations';
import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import { webSocketActions } from '@/store/modules/websocket/websocket.actions';
import { webSocketGetters } from './websocket.getters';

export default {
    namespaced: true,
    state: webSocketState,
    actions: webSocketActions,
    mutations: webSocketMutations,
    getters: webSocketGetters
} as unknown as ModuleTree<RootState>;